export default function(value) {
    return value.replace(/&\w+;br ?\/&\w+;/g, ',');
}
